module.exports = "  <div class=\"tab-slide\" #tabSlide>\n      <ng-content></ng-content>\n  </div> "